export const urls = {
    ACCOUNT: '/account',
    DASHBOARD: '/dashboard',

    auth: {
        IMPERSONATE: '/auth/impersonate',
        LOGIN: '/auth/login',
        RESET_PASSWORD: '/auth/reset-password',
    },

    catalogue: {
        DISCOUNTS: '/catalogue/discounts',
        INDEX: '/catalogue',
        PRICE_TABLES: '/catalogue/price-tables',

        product: {
            CREATE: '/catalogue/products/create',
            DETAILS: '/catalogue/products/:id',
            IMPORT: '/catalogue/products/import',
            LIST: '/catalogue/products',
        },

        suppliers: {
            CREATE: '/catalogue/suppliers/create',
            DETAILS: '/catalogue/suppliers/:id',
            LIST: '/catalogue/suppliers',
        },
    },

    machines: {
        ALL: '/machines/all',
        INDEX: '/machines',
        MARKETING: '/machines/:id/marketing',
        TECHNICAL_DATA: '/machines/:id/technical-data',

        microwaves: {
            CREATE: '/machines/microwaves/create',
            DETAILS: '/machines/microwaves/:id',
            LIST: '/machines/microwaves',
            SETTINGS: '/machines/microwaves/:id/settings',
        },

        planograms: {
            CREATE: '/machines/planograms/create/:id',
            DETAILS: '/machines/planograms/:id',
            LIST: '/machines/planograms',
            PRODUCT_INFO: '/machines/planograms/:id/product-info',
            TECHNICAL_DATA: '/machines/planograms/:id/technical-data',
        },
    },

    operations: {
        DELIVERIES: '/operations/deliveries',
        DESTOCKING: '/operations/destocking',
        ENCODED_PRODUCTS: '/operations/encoded-products',
        INCIDENTS: '/operations/incidents',
        INDEX: '/operations',
        INTERVENTIONS: '/operations/interventions',
        INCIDENTS_RABBITMQ: '/operations/rabbitmq-incidents',

        orders: {
            CREATE: '/operations/orders/create',
            DETAILS: '/operations/orders/:id',
            LIST: '/operations/orders',
        },
    },

    park: {
        INDEX: '/park',

        clients: {
            CREATE: '/park/clients/create',
            DETAILS: '/park/clients/:id',
            LIST: '/park/clients',
        },

        managers: {
            CREATE: '/park/managers/create',
            DETAILS: '/park/managers/:id',
            LIST: '/park/managers',
        },

        sites: {
            CREATE: '/park/sites/create',
            DETAILS: '/park/sites/:id',
            LIST: '/park/sites',
        },
    },

    reports: {
        INDEX: '/reports',
        STOCK: '/reports/stock',
        SUPPLY: '/reports/supply',

        sale: {
            CREATE: '/reports/sale/create',
            DETAILS: '/reports/sale/:id',
            LIST: '/reports/sale',
        },

        service: {
            CREATE: '/reports/service/create',
            DETAILS: '/reports/service/:id',
            LIST: '/reports/service',
        },

        vat: {
            CREATE: '/reports/vat/create',
            DETAILS: '/reports/vat/:id',
            LIST: '/reports/vat',
        },
    },

    settings: {
        CATEGORIES: '/settings/categories',
        EMAIL: '/settings/email',
        INDEX: '/settings',
        THEME: '/settings/theme',
        TICKET: '/settings/ticket',
    },

    transactions: {
        BLOCKED_CARDS: '/transactions/blocked-cards',
        INDEX: '/transactions',
        REFILLS: '/transactions/refills',
        REFUNDS: '/transactions/refunds',

        sales: {
            DETAILS: '/transactions/sales/:id',
            LIST: '/transactions/sales',
        },
    },

    users: {
        INDEX: '/users',
        KONVIVES: '/users/konvives',

        deliveryMen: {
            CREATE: '/users/delivery-men/create',
            DETAILS: '/users/delivery-men/:id',
            LIST: '/users/delivery-men',
        },

        konsole: {
            CREATE: '/users/konsole/create',
            DETAILS: '/users/konsole/:id',
            LIST: '/users/konsole',
        },

        profiles: {
            CREATE: '/users/profiles/create',
            DETAILS: '/users/profiles/:id',
            LIST: '/users/profiles',
        },

        services: {
            CREATE: '/users/services/create',
            DETAILS: '/users/services/:id',
            LIST: '/users/services',
        },

        technicians: {
            CREATE: '/users/technicians/create',
            DETAILS: '/users/technicians/:id',
            LIST: '/users/technicians',
        },
    },
}
